/* =====================================================================
   AirBreazy - personalizzazioni del configuratore Starter Kit
   25 AGO 2026

   Questo file sta fuori dalla sezione per due motivi:
   1) sections/starter-kit.liquid era gia al 97% del limite di 256 KB che
      Shopify impone al corpo di un template. Ogni riga aggiunta li dentro
      avvicinava il file al muro oltre il quale non e piu caricabile.
   2) qui il browser lo mette in cache e non lo riscarica a ogni pagina,
      mentre il codice scritto dentro l'HTML va riletto ogni volta.

   Va caricato SENZA defer, nello stesso punto in cui stava prima il codice
   in linea: deve girare mentre la pagina si sta ancora costruendo, prima
   del primo disegno a schermo.
   ===================================================================== */
(function () {
  var script = document.currentScript;
  var azzeraNucleiAttivo = !!(script && script.dataset.azzeraNuclei === 'true');
  var TESTO_DISPOSITIVO = (script && script.dataset.testoDispositivo) || '';
  var TESTO_NUCLEI = (script && script.dataset.testoNuclei) || '';
  var TESTO_FINALE = (script && script.dataset.testoFinale) || '';

  /* ---------- Schede piano (ex jQuery) --------------------------------
     Erano otto righe di jQuery, e per averle si caricava una libreria da
     ~30 KB da un dominio esterno con uno script bloccante. Stesso
     comportamento, zero dipendenze. */
  function attivaSchede() {
    document.querySelectorAll('ul.tabs li').forEach(function (voce) {
      voce.addEventListener('click', function () {
        var idScheda = voce.getAttribute('data-tab');
        document.querySelectorAll('ul.tabs li').forEach(function (v) { v.classList.remove('current'); });
        document.querySelectorAll('.tab-content').forEach(function (c) { c.classList.remove('current'); });
        voce.classList.add('current');
        var bersaglio = idScheda ? document.getElementById(idScheda) : null;
        if (bersaglio) bersaglio.classList.add('current');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attivaSchede);
  } else {
    attivaSchede();
  }

  /* ---------- Barra fissa di acquisto (solo telefono) -----------------
     Il tema mostra una barra fissa in fondo allo schermo con il pulsante
     di acquisto, e la teneva sempre accesa: cosi, arrivati in fondo al
     configuratore, il cliente vedeva DUE "Aggiungi al carrello" uno sopra
     l'altro. Qui la barra viene nascosta finche il pulsante vero e a
     schermo, e ricompare appena esce. */
  /* Nota: qui si usa un semplice controllo sulla posizione ad ogni scroll,
     non IntersectionObserver. Quest'ultimo, agganciato in questa pagina, non
     richiamava mai la funzione (il configuratore fa parecchie acrobazie sul
     layout). Un controllo diretto e una riga di codice in piu ma si vede
     esattamente cosa fa, e il costo e trascurabile perche e limitato a un
     fotogramma per scroll. */
  var barraFissa = null;
  var bottoneStatico = null;

  var tastieraAperta = false;

  function aggiornaBarraFissa() {
    if (!barraFissa || !bottoneStatico) return;
    var r = bottoneStatico.getBoundingClientRect();
    var altezza = window.innerHeight || document.documentElement.clientHeight;
    /* La barra si spegne SOLO se il pulsante vero e' tutto a schermo e
       con un po' d'aria intorno. Prima bastava che se ne vedesse un
       terzo, e c'era un momento - il pulsante mezzo tagliato in fondo
       allo schermo - in cui la barra era gia' sparita e il pulsante non
       era ancora leggibile: nessuno dei due utilizzabile. Meglio
       sovrapporli per un istante che lasciare il cliente senza pulsante
       di acquisto. */
    var ARIA_SOPRA = 8;
    var ARIA_SOTTO = 72;
    var tuttoASchermo = r.top >= ARIA_SOPRA && r.bottom <= altezza - ARIA_SOTTO;
    barraFissa.classList.toggle('ab-barra-nascosta', tuttoASchermo || tastieraAperta);
  }

  /* ---------- Barra fissa e tastiera del telefono ---------------------
     Su telefono, con la tastiera aperta lo schermo utile si riduce a una
     striscia: il pannello dell'incisione, la tastiera e la barra fissa
     dell'acquisto insieme non ci stanno, e il cliente si ritrova a
     scrivere dentro una fessura. Quindi finche' sta scrivendo la barra
     si toglie di mezzo, e torna appena ha finito.

     Ci si basa sul fuoco in un campo di testo, non sull'altezza della
     finestra: i browser dei telefoni ridimensionano la finestra in modi
     diversi tra loro quando appare la tastiera, mentre il fuoco e' un
     segnale netto e uguale ovunque.

     Solo sotto i 750px: sul computer scrivere in un campo non apre
     nessuna tastiera e la barra deve restare dov'e'.                    */
  function eCampoDiTesto(el) {
    if (!el || !el.tagName) return false;
    var t = el.tagName.toLowerCase();
    if (t === 'textarea') return true;
    if (el.isContentEditable) return true;
    if (t !== 'input') return false;
    var tipo = (el.getAttribute('type') || 'text').toLowerCase();
    return ['text', 'search', 'email', 'tel', 'url', 'number', 'password'].indexOf(tipo) !== -1;
  }

  function suTelefono() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  var attesaChiusura = null;
  function segnalaTastiera(aperta) {
    if (attesaChiusura) { clearTimeout(attesaChiusura); attesaChiusura = null; }
    if (tastieraAperta === aperta) return;
    tastieraAperta = aperta;
    aggiornaBarraFissa();
  }

  document.addEventListener('focusin', function (e) {
    if (!suTelefono() || !eCampoDiTesto(e.target)) return;
    segnalaTastiera(true);
  }, true);

  document.addEventListener('focusout', function (e) {
    if (!eCampoDiTesto(e.target)) return;
    /* Piccola attesa: passando da un campo all'altro - con The Bond ce
       ne sono due - il fuoco esce e rientra, e senza questo respiro la
       barra farebbe un lampo in mezzo. */
    if (attesaChiusura) clearTimeout(attesaChiusura);
    attesaChiusura = setTimeout(function () {
      attesaChiusura = null;
      tastieraAperta = false;
      aggiornaBarraFissa();
    }, 150);
  }, true);

  /* Il controllo si fa subito, senza requestAnimationFrame: in una scheda
     in secondo piano il browser lo mette in pausa, e la barra resterebbe
     ferma nello stato sbagliato. Un getBoundingClientRect per scroll costa
     nulla, e il piccolo freno qui sotto evita di ripeterlo all'infinito. */
  var ultimoControllo = 0;
  function chiediControllo() {
    var ora = (window.performance && performance.now) ? performance.now() : +new Date();
    if (ora - ultimoControllo < 60) return;
    ultimoControllo = ora;
    aggiornaBarraFissa();
  }

  function gestisciBarraFissa() {
    barraFissa = document.getElementById('fixed-add-to-cart');
    if (!barraFissa) return;

    /* Attenzione: i due pulsanti hanno lo stesso id (lo duplica il tema),
       quindi getElementById non basta: serve quello FUORI dalla barra. */
    var candidati = document.querySelectorAll('[id="add-to-cart-submit-button"]');
    for (var i = 0; i < candidati.length; i++) {
      if (!candidati[i].closest('#fixed-add-to-cart')) { bottoneStatico = candidati[i]; break; }
    }
    if (!bottoneStatico) return;

    aggiornaBarraFissa();
    /* In ascolto su document con capture: l'evento scroll non risale la
       gerarchia, e in questa pagina non e detto che a scorrere sia la
       finestra. Cosi si intercetta lo scorrimento di qualunque contenitore. */
    document.addEventListener('scroll', chiediControllo, { capture: true, passive: true });
    window.addEventListener('resize', chiediControllo, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gestisciBarraFissa);
  } else {
    gestisciBarraFissa();
  }
  window.addEventListener('load', gestisciBarraFissa);

  if (!azzeraNucleiAttivo) return;

  /* ---------- Nuclei non preselezionati (step 2) ----------------------
     Il tema riempie i nuclei da solo all'avvio ed e proprio quel
     riempimento a fargli calcolare il prezzo reale del pack: senza, in
     pagina resterebbe il numero scritto a mano dentro onLoadPrice(), oggi
     non piu aggiornato. Quindi si lascia lavorare il tema e subito dopo si
     azzerano i contatori, senza usare i pulsanti +/- che farebbero
     scattare il cambio automatico di pack. */

  var CHIAVE_BLOCCO = 'data-preselezione-blocco-pack';
  var packIniziale = null;
  var elPack = document.querySelector('.pack-option.selected');
  if (elPack) packIniziale = elPack.dataset.pack;

  function nucleiSelezionati() {
    var n = 0;
    document.querySelectorAll('#fum-flavor-cores-step-2 input.flavor-quantity')
      .forEach(function (i) { n += Number(i.value) || 0; });
    return n;
  }

  function ripristinaPack() {
    if (!packIniziale) return;
    var target = document.querySelector('.pack-option[data-pack="' + packIniziale + '"]');
    if (!target) return;
    if (!target.classList.contains('selected')) {
      document.querySelectorAll('.pack-option').forEach(function (p) { p.classList.remove('selected'); });
      target.classList.add('selected');
    }
    /* Con zero nuclei la selezione automatica del pack retrocederebbe al
       pack piu piccolo. Il tema rispetta data-manually-selected, quindi lo
       usiamo come fermo temporaneo: viene tolto appena il cliente sceglie
       il primo nucleo, cosi il comportamento automatico torna l'originale. */
    if (!target.dataset.manuallySelected) {
      target.dataset.manuallySelected = 'true';
      target.setAttribute(CHIAVE_BLOCCO, 'true');
    }
  }

  function togliBloccoPack() {
    document.querySelectorAll('[' + CHIAVE_BLOCCO + ']').forEach(function (el) {
      delete el.dataset.manuallySelected;
      el.removeAttribute(CHIAVE_BLOCCO);
    });
  }

  /* Il contatore "x / y" della barra d'acquisto resta fermo al valore
     lasciato dal riempimento automatico del tema: con i nuclei azzerati
     diceva "6 / 6", cioe sembrava gia completo quando non era stato
     scelto niente. Lo riportiamo a zero e gli rimettiamo come massimo la
     taglia del pack selezionato, cosi i due numeri raccontano sempre la
     stessa cosa. Sono due elementi con lo stesso id (li duplica il
     tema), quindi si passa da querySelectorAll. */
  function allineaContatore() {
    var packSel = document.querySelector('.pack-selector .pack-option.selected');
    document.querySelectorAll('[id="qty-selected"]').forEach(function (box) {
      var scelti = box.querySelector('.selected-pack');
      var massimo = box.querySelector('.max-pack');
      if (scelti) scelti.textContent = '0';
      if (massimo && packSel) massimo.textContent = packSel.dataset.pack;
    });
  }

  /* ------------------------------------------------------------------
     Riallineamento dopo il cambio di pack

     IL DIFETTO: passando da un pack all'altro, il contatore sotto il
     pulsante restava indietro. Si vedevano sei nuclei accesi nelle
     piastrelle e "3/6" scritto sotto, con il messaggio che ne chiedeva
     altri tre. Numeri che si contraddicono in una pagina di acquisto
     sono il modo piu veloce per far chiudere la scheda.

     LA CAUSA: nel tema il contatore, la barra di avanzamento, il
     messaggio di validazione e il testo del pulsante li scrive una sola
     funzione, validationFn, che pero viene chiamata quando si tocca un
     NUCLEO. Il click su un pack non la chiama: quel gestore si limita a
     spostare la classe "selected" da un riquadro all'altro. Finche non
     si toccava un nucleo, quei numeri restavano quelli di prima.

     LA FONTE DELLA VERITA sono gli input .flavor-quantity: sono loro a
     finire nel carrello. I contatori visibili sono solo il riflesso, e
     quando i due si separano vince l'input, se no il cliente comprerebbe
     una cosa diversa da quella che vede.
     ------------------------------------------------------------------ */
  function sincronizzaDopoCambioPack() {
    var packSel = document.querySelector('.pack-selector .pack-option.selected');
    if (!packSel) return;
    var taglia = Number(packSel.dataset.pack) || 0;

    /* 1. i contatori visibili tornano a dire quello che dicono gli input */
    document.querySelectorAll('#fum-flavor-cores-step-2 .flavor').forEach(function (f) {
      var inp = f.querySelector('input.flavor-quantity');
      if (!inp) return;
      var n = Number(inp.value) || 0;
      var c = f.querySelector('.fum-quantity-counter');
      if (c) c.textContent = String(n);
      var hid = f.querySelector('.quantity-selector input[type=number]');
      if (hid) hid.value = n;
      var qs = f.querySelector('.quantity-selector');
      var fs = f.querySelector('.flav-select');
      if (qs) qs.style.display = n > 0 ? 'flex' : 'none';
      if (fs) fs.style.display = n > 0 ? 'none' : '';
    });

    var scelti = nucleiSelezionati();
    var mancanti = Math.max(0, taglia - scelti);

    /* 2. contatore x/y - sono due elementi con lo stesso id, li duplica
          il tema per la barra fissa in fondo */
    document.querySelectorAll('[id="qty-selected"]').forEach(function (box) {
      var a = box.querySelector('.selected-pack');
      var b = box.querySelector('.max-pack');
      if (a) a.textContent = String(scelti);
      if (b) b.textContent = String(taglia);
    });

    /* 3. quanti ne mancano */
    document.querySelectorAll('[id="validation-count"]').forEach(function (el) {
      el.textContent = String(mancanti);
    });

    /* 4. barra di avanzamento */
    var larghezza = taglia > 0 ? Math.min((scelti / taglia) * 100, 100) : 0;
    document.querySelectorAll('.progress').forEach(function (el) {
      el.style.width = larghezza + '%';
    });

    /* 5. il "3/6" davanti al testo del pulsante. Si riscrive solo la
          parte numerica: il resto e' tradotto e non va toccato. */
    document.querySelectorAll('[id="cart-btn-text"]').forEach(function (el) {
      el.textContent = el.textContent.replace(/\d+\s*\/\s*\d+/, scelti + '/' + taglia);
    });

    /* 6. l'avviso "ne mancano N". Aggiornare il numero non bastava: con
          il pack completo restava a schermo un cartello arancione che
          chiedeva zero nuclei, accanto a un pulsante gia sbloccato. Il
          tema lo mostra e lo nasconde con display flex/none, e qui si fa
          lo stesso per non inventare un secondo modo di nasconderlo. */
    document.querySelectorAll('[id="validation-error"]').forEach(function (el) {
      el.style.display = mancanti > 0 ? 'flex' : 'none';
    });

    if (typeof updateSubmitButtonState === 'function') updateSubmitButtonState();
    togliPuntinoOrfano();
    setTimeout(togliPuntinoOrfano, 60);
  }

  /* ------------------------------------------------------------------
     Il puntino orfano sul pulsante di acquisto

     Il tema scrive nel pulsante "AGGIUNGI AL CARRELLO . " con un punto
     separatore in coda, e subito dopo riempie di prezzo lo spazio che
     segue. Cambiando pack, per una frazione di secondo il testo c'e' gia
     e il prezzo no: resta a schermo un puntino sospeso nel vuoto.

     Qui lo si toglie, ma SOLO finche il prezzo e' vuoto. Appena il tema
     lo calcola riscrive lui il testo col separatore, e questa funzione
     non tocca piu niente: non puo mangiarsi un punto che serve davvero,
     perche' guarda prima se c'e qualcosa dopo.                          */
  function togliPuntinoOrfano() {
    document.querySelectorAll('[id="add-to-cart-submit-button"]').forEach(function (btn) {
      var testo = btn.querySelector('[id="cart-btn-text"]');
      var prezzo = btn.querySelector('[id="add-to-cart-price"]');
      if (!testo || !prezzo) return;
      if (prezzo.textContent.trim()) return;
      testo.textContent = testo.textContent.replace(/[\s\u2022\u00b7|]+$/, '');
    });
  }

  /* Il gestore del tema sposta la classe "selected" al click; il nostro
     gira subito dopo, a stato gia cambiato. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.pack-selector .pack-option')) return;
    setTimeout(sincronizzaDopoCambioPack, 120);
  }, true);

  function azzeraNuclei() {
    var flavors = document.querySelectorAll('#fum-flavor-cores-step-2 .flavor');
    if (!flavors.length) return;
    flavors.forEach(function (f) {
      var inp = f.querySelector('input.flavor-quantity');
      if (inp) inp.value = 0;
      var c = f.querySelector('.fum-quantity-counter');
      if (c) c.textContent = '0';
      var hid = f.querySelector('.quantity-selector input[type=number]');
      if (hid) hid.value = 0;
      var qs = f.querySelector('.quantity-selector');
      if (qs) qs.style.display = 'none';
      var fs = f.querySelector('.flav-select');
      if (fs) {
        fs.style.display = '';
        fs.classList.remove('selected', 'solid');
        fs.classList.add('outline');
      }
    });
    var dot = document.querySelector('.step-2 h2[data-step-number="2"] span');
    if (dot) dot.classList.remove('filled-circle');
    ripristinaPack();
    allineaContatore();
    if (typeof updateSubmitButtonState === 'function') updateSubmitButtonState();
  }

  /* Con zero nuclei il tema non aggiorna il prezzo quando si passa da
     acquisto singolo ad abbonamento: e un ramo che prima non veniva mai
     raggiunto. Rifacciamo lo stesso giro del caricamento. */
  function ricalcolaSeVuoto() {
    if (nucleiSelezionati() > 0) return;
    if (typeof defaultSelectionPacks !== 'function') return;
    defaultSelectionPacks();
    azzeraNuclei();
  }

  var pianoAgganciato = false;
  function agganciaCambioPiano() {
    if (pianoAgganciato) return;
    var radios = document.querySelectorAll('.custom-journey-pack .subscription-plan input[name=subscription]');
    if (!radios.length) return;
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { setTimeout(ricalcolaSeVuoto, 60); });
    });
    pianoAgganciato = true;
  }

  function sorvegliaPrimaScelta() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var dentroNuclei = e.target.closest('#fum-flavor-cores-step-2');
      var suPack = e.target.closest('.pack-option');
      if (!dentroNuclei && !suPack) return;
      setTimeout(function () {
        if (suPack || nucleiSelezionati() > 0) togliBloccoPack();
      }, 0);
    }, true);
  }

  /* ===================================================================
     GUARDIA SUL PULSANTE DI ACQUISTO - 26 AGO 2026

     Il tema ha gia una funzione updateSubmitButtonState() che decide se
     il pulsante va abilitato, ma la applica a "#cart-submit-button",
     mentre il pulsante che il cliente vede davvero e
     "#add-to-cart-submit-button" (ce ne sono due con lo stesso id: quello
     nel configuratore e quello nella barra fissa in basso). Risultato: il
     pulsante visibile veniva spento solo dal gestore del clic sui nuclei,
     quindi finche il cliente non toccava un nucleo restava cliccabile —
     e si poteva aggiungere al carrello con zero nuclei.

     Qui la stessa regola del tema (dispositivo scelto E numero di nuclei
     pari alla taglia del pack) viene applicata ai pulsanti giusti, a
     ogni clic e al caricamento. Non tocca il codice dei dev: si limita a
     rimettere a posto lo stato.
     =================================================================== */
  function pulsantiAcquisto() {
    return [
      document.querySelector('.custom-journey-pack #add-to-cart-submit-button'),
      document.querySelector('#fixed-add-to-cart #add-to-cart-submit-button')
    ].filter(Boolean);
  }

  function sceltaCompleta() {
    var dispositivo = document.querySelector('#custom-product .step_one_cls .select-button.selected');
    if (!dispositivo) return false;
    /* 31 AGO 2026 - si guarda la taglia del pack SCELTO, non una taglia
       qualsiasi. Prima bastava arrivare a 3, 6 o 10 nuclei perche' il
       pulsante si accendesse: col 6-PACK selezionato diventava verde
       gia' al terzo nucleo e il cliente si fermava li'. Ora dice
       "3/6 selezionati" e resta spento finche' il pack non e' pieno. */
    var scelto = document.querySelector('.pack-selector .pack-option.selected');
    if (scelto) {
      var taglia = Number(scelto.dataset.pack) || 0;
      if (taglia) return nucleiSelezionati() === taglia;
    }
    var taglie = [];
    document.querySelectorAll('.pack-selector .pack-option').forEach(function (p) {
      taglie.push(Number(p.dataset.pack));
    });
    if (!taglie.length) return true;
    return taglie.indexOf(nucleiSelezionati()) !== -1;
  }

  /* Il pulsante deve anche dire COSA manca. Le tre scritte esistono gia
     nei file di lingua del tema (elige dispositivo / elige nucleos /
     aggiungi al carrello): arrivano qui dai data-attribute del tag
     script, cosi restano tradotte mercato per mercato.
     Il pallino separatore prima del prezzo lo mette sempre questa
     funzione: il tema lo scriveva solo in alcuni dei suoi rami. */
  function etichettaGiusta() {
    var dispositivo = document.querySelector('#custom-product .step_one_cls .select-button.selected');
    if (!dispositivo) return TESTO_DISPOSITIVO;
    if (nucleiSelezionati() === 0) return TESTO_NUCLEI;
    if (!sceltaCompleta()) return null;   /* il tema scrive "3/6 selezionati": va bene */
    return TESTO_FINALE;
  }

  function sistemaPulsanti() {
    var valida = sceltaCompleta();
    pulsantiAcquisto().forEach(function (b) {
      if (valida) b.removeAttribute('disabled');
      else b.setAttribute('disabled', 'disabled');
      b.classList.toggle('disabled', !valida);

      var etichetta = b.querySelector('#cart-btn-text');
      if (!etichetta) return;
      var nuova = etichettaGiusta();
      if (nuova) etichetta.textContent = nuova;
      /* Il pallino separa l'etichetta dal prezzo: se il prezzo non si
         vede (impostazione "Pulsante di acquisto: nessun prezzo") non
         separa niente e resterebbe li' appeso. Ci si regola guardando
         se l'elemento del prezzo e' davvero a schermo, cosi' segue da
         solo l'interruttore senza saperne niente. */
      var elPrezzo = b.querySelector('#add-to-cart-price');
      var prezzoVisibile = !!elPrezzo && elPrezzo.offsetParent !== null && elPrezzo.textContent.trim() !== '';
      var testo = etichetta.textContent.replace(/\s*[•·]\s*$/, '').replace(/\s+$/, '');
      if (testo) etichetta.textContent = prezzoVisibile ? testo + ' \u2022 ' : testo;
    });
  }

  document.addEventListener('click', function () { setTimeout(sistemaPulsanti, 40); }, true);
  document.addEventListener('change', function () { setTimeout(sistemaPulsanti, 40); }, true);

  azzeraNuclei();
  sistemaPulsanti();
  sorvegliaPrimaScelta();
  document.addEventListener('DOMContentLoaded', function () { azzeraNuclei(); agganciaCambioPiano(); sistemaPulsanti(); });
  window.addEventListener('load', function () { azzeraNuclei(); agganciaCambioPiano(); sistemaPulsanti(); });

  /* ---------- Accessori aperti insieme ai nuclei ---------------------
     Il tema apre uno step alla volta: aprendone uno chiude tutti gli
     altri. Sui dispositivi ha senso - scegli e passi oltre - ma sui
     nuclei no: lo step 2 resta aperto a lungo perche il cliente aggiunge,
     toglie e cambia gusti, e finche resta aperto gli accessori sono
     chiusi sotto e nessuno li vede. Bisogna sapere di dover scorrere.

     Sul riferimento (eu.tryfum.com) gli accessori sono visibili da
     subito, verificato: la loro scheda misura 220x280 gia al primo
     caricamento. Qui si fa una via di mezzo: restano chiusi finche il
     cliente e sui dispositivi, e si aprono appena arriva ai nuclei.

     Si avvolge la funzione del tema invece di riscriverla: la sua
     logica resta quella, noi aggiungiamo solo la riapertura del terzo
     step subito dopo. Aprirlo chiamando di nuovo toggleStep non si puo,
     perche quella chiude tutto prima di aprire.                       */
  function accessoriInsiemeAiNuclei() {
    if (typeof window.toggleStep !== 'function') return;
    if (window.__abAccessoriAgganciati) return;
    window.__abAccessoriAgganciati = true;

    var originale = window.toggleStep;
    window.toggleStep = function (numero, apri) {
      originale.apply(this, arguments);
      if (!apri || String(numero) !== '2') return;
      var terzo = document.querySelector('.step-content[data-step-number="3"]');
      if (!terzo) return;
      terzo.setAttribute('aria-expanded', 'true');
      terzo.style.display = 'grid';
      var passo = terzo.closest('.step');
      var titolo = passo ? passo.querySelector('.step-title') : null;
      if (titolo) titolo.style.opacity = '1';
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', accessoriInsiemeAiNuclei);
  } else {
    accessoriInsiemeAiNuclei();
  }
  window.addEventListener('load', accessoriInsiemeAiNuclei);
})();

/* =====================================================================
   Finestra dell'aroma: tutte della stessa altezza - 30 AGO 2026

   IL DIFETTO
   La finestra e' una sola, riusata per tutti gli aromi: il tema le
   riscrive dentro foto, nome, note e descrizione a ogni cambio di
   gusto. Le descrizioni pero' non sono lunghe uguali - alcune stanno su
   una riga, altre su due - e la finestra cambiava altezza sotto il
   dito, saltando su e giu ogni volta che si premeva una freccia.

   LA CORREZIONE
   Prima di mostrarla, si provano dentro tutte le descrizioni e tutte le
   note e ci si segna la piu alta. Quella misura diventa l'altezza
   minima dei due blocchi: da li in poi la finestra e' identica per
   tutti gli aromi, e tutto quello che sta sotto - la riga disegnata, la
   frase dei tre giorni - resta fermo al suo posto.

   PERCHE' MISURATA E NON SCRITTA A MANO
   Un numero fisso funzionerebbe oggi in spagnolo e sarebbe sbagliato
   domani in tedesco, che e' piu lungo, o su un telefono stretto, dove
   le righe raddoppiano. Misurando, la regola si adatta da sola a ogni
   lingua e a ogni schermo - e si rifa il conto quando si gira il
   telefono.

   COME SI MISURA UNA COSA NASCOSTA
   La finestra parte con display:none e una cosa nascosta cosi' non ha
   altezza. Per il tempo della misura le si da display:block insieme a
   visibility:hidden: occupa spazio, quindi si puo misurare, ma resta
   invisibile. Il browser non ridisegna niente in mezzo, quindi non si
   vede nessun lampo.
   ===================================================================== */
(function () {
  var rifaiPiuTardi = null;

  function pareggiaFinestraAroma() {
    var finestra = document.getElementById('flavor-modal');
    if (!finestra) return;

    var descrizione = finestra.querySelector('.flavor-modal-description');
    var note = finestra.querySelector('.flavor-modal-notes');
    if (!descrizione || !note) return;

    var forte = note.querySelector('strong');
    if (!forte) return;

    var schede = document.querySelectorAll('.flavor:not(.expore_cls):not(.step-3 .flavor)');
    if (!schede.length) return;

    /* la si rende misurabile senza renderla visibile */
    var eraChiusa = finestra.style.display !== 'block';
    var visibilitaPrima = finestra.style.visibility;
    if (eraChiusa) {
      finestra.style.visibility = 'hidden';
      finestra.style.display = 'block';
    }

    var testoDescrizione = descrizione.textContent;
    var testoNote = forte.textContent;

    descrizione.style.minHeight = '';
    note.style.minHeight = '';

    var altaDescrizione = 0;
    var alteNote = 0;

    for (var i = 0; i < schede.length; i++) {
      descrizione.textContent = schede[i].getAttribute('data-description') || '';
      forte.textContent = schede[i].getAttribute('data-notes') || '';
      var a = descrizione.getBoundingClientRect().height;
      var b = note.getBoundingClientRect().height;
      if (a > altaDescrizione) altaDescrizione = a;
      if (b > alteNote) alteNote = b;
    }

    descrizione.textContent = testoDescrizione;
    forte.textContent = testoNote;

    if (altaDescrizione > 0) descrizione.style.minHeight = Math.ceil(altaDescrizione) + 'px';
    if (alteNote > 0) note.style.minHeight = Math.ceil(alteNote) + 'px';

    if (eraChiusa) {
      finestra.style.display = 'none';
      finestra.style.visibility = visibilitaPrima;
    }
  }

  /* i caratteri cambiano la misura del testo: si aspetta che siano
     arrivati, se no si misura con quello di ripiego e viene stretto */
  function quandoPronto() {
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(pareggiaFinestraAroma);
    } else {
      pareggiaFinestraAroma();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', quandoPronto);
  } else {
    quandoPronto();
  }
  window.addEventListener('load', quandoPronto);

  /* girando il telefono cambia la larghezza, e con essa il numero di
     righe: si rifa il conto, ma non a ogni pixel di ridimensionamento */
  window.addEventListener('resize', function () {
    if (rifaiPiuTardi) clearTimeout(rifaiPiuTardi);
    rifaiPiuTardi = setTimeout(pareggiaFinestraAroma, 250);
  });
})();

/* =====================================================================
   Finestra dell'aroma: si cambia gusto scorrendo col dito - 30 AGO 2026

   Sul telefono le due frecce sono piccole e stanno sopra alla foto: per
   passare all'aroma dopo bisogna centrare un bersaglio da 32px. Scorrere
   e' il gesto che uno fa d'istinto davanti a una foto, quindi la
   finestra ora lo accetta - le frecce restano dove sono, per chi usa il
   mouse e per chi si aspetta di vederle.

   NON RIFA' IL LAVORO DELLE FRECCE
   Alla fine dello scorrimento questo codice preme la freccia giusta,
   invece di cambiare l'aroma per conto suo. Cosi' c'e' un solo posto
   che decide cosa succede quando si cambia gusto, e se un domani quel
   posto cambia, lo scorrimento lo segue senza saperlo.

   QUANDO NON DEVE SCATTARE
   - se il dito e' andato piu' in verticale che in orizzontale: quello
     e' uno scorrimento della pagina, non un cambio di aroma
   - se ha percorso meno di 45px: e' un tocco storto, non un gesto
   - se ci sono due dita: e' uno zoom
   - se la freccia da premere e' nascosta, cioe' siamo al primo o
     all'ultimo aroma: si resta dove si e'

   Gli ascoltatori sono "passive": dichiarano di non voler bloccare lo
   scorrimento della pagina, e il telefono puo' continuare a scorrere
   fluido senza aspettare che questo codice decida.
   ===================================================================== */
(function () {
  var DISTANZA_MINIMA = 45;

  function agganciaScorrimento() {
    var finestra = document.getElementById('flavor-modal');
    if (!finestra || finestra.dataset.abScorrimento === 'si') return;
    finestra.dataset.abScorrimento = 'si';

    var partenzaX = 0;
    var partenzaY = 0;
    var valido = false;

    finestra.addEventListener('touchstart', function (e) {
      valido = e.touches.length === 1;
      if (!valido) return;
      partenzaX = e.touches[0].clientX;
      partenzaY = e.touches[0].clientY;
    }, { passive: true });

    finestra.addEventListener('touchend', function (e) {
      if (!valido) return;
      valido = false;

      var tocco = e.changedTouches && e.changedTouches[0];
      if (!tocco) return;

      var spostamentoX = tocco.clientX - partenzaX;
      var spostamentoY = tocco.clientY - partenzaY;

      if (Math.abs(spostamentoX) < DISTANZA_MINIMA) return;
      if (Math.abs(spostamentoX) <= Math.abs(spostamentoY)) return;

      /* dito verso sinistra = si va avanti, come sfogliare */
      var freccia = finestra.querySelector(spostamentoX < 0 ? '.right-arrow' : '.left-arrow');
      if (!freccia) return;
      if (getComputedStyle(freccia).display === 'none') return;

      freccia.click();
    }, { passive: true });

    finestra.addEventListener('touchcancel', function () {
      valido = false;
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', agganciaScorrimento);
  } else {
    agganciaScorrimento();
  }
  window.addEventListener('load', agganciaScorrimento);
})();


/* =====================================================================
   I NUCLEI SONO DEL CLIENTE - 1 SET 2026

   Cambiando pacchetto il tema faceva cosi': azzerava TUTTI i nuclei e
   li rimetteva partendo dal primo gusto dell'elenco. Chi aveva scelto
   Menta Verde e Pomelo e passava dal 6 al 10 se li ritrovava sostituiti
   da Menta Fresca e Mango: la pagina buttava via la sua scelta e ne
   faceva un'altra al posto suo.

   Le regole adesso sono tre, e vengono tutte dalla stessa idea - quello
   che ha scelto il cliente non si tocca:

   1. verso un pacchetto piu' GRANDE si tiene tutto e si completa con
      gusti non ancora scelti;
   2. verso un pacchetto piu' PICCOLO cadono per primi quelli che aveva
      messo la pagina, e per ultimi quelli scelti dal cliente (il taglio
      lo fa gia' il tema partendo dal fondo: qui non lo tocchiamo);
   3. quello che e' stato tolto si tiene da parte, e risalendo di
      pacchetto torna al suo posto prima di pescare gusti nuovi. Chi
      sbaglia pacchetto e torna indietro non perde niente.

   Sta qui e non dentro la sezione perche' il corpo di
   starter-kit.liquid e' vicino al limite dei 256 KB. La sezione chiama
   solo window.abNuclei.completa().
   ===================================================================== */
(function () {
  var SEL_NUCLEI = '#fum-flavor-cores-step-2 .flavor';
  /* la pila di quello che i cambi di pacchetto hanno tolto, dal piu'
     vecchio al piu' recente: si ripesca dal fondo */
  var memoria = [];
  var MAX_MEMORIA = 30;

  function schede() {
    return [].slice.call(document.querySelectorAll(SEL_NUCLEI)).filter(function (s) {
      return !!s.querySelector('input.flavor-quantity');
    });
  }

  function quantita(scheda) {
    var i = scheda.querySelector('input.flavor-quantity');
    return i ? Number(i.value) || 0 : 0;
  }

  function totale() {
    var n = 0;
    schede().forEach(function (s) { n += quantita(s); });
    return n;
  }

  /* Si aggiunge una unita' come farebbe il cliente, col pulsante: il
     tema aggancia a quel clic il prezzo, il contatore e la barra, e
     scrivendo direttamente nell'input resterebbero tutti indietro. */
  function aggiungiUno(scheda) {
    if (quantita(scheda) === 0) {
      var scegli = scheda.querySelector('.flav-select');
      if (!scegli) return false;
      scegli.click();
      return true;
    }
    var piu = scheda.querySelector('.quantity-selector .plus-btn');
    if (!piu) return false;
    piu.click();
    return true;
  }

  function istantanea() {
    var m = [];
    schede().forEach(function (s) { m.push([s, quantita(s)]); });
    return m;
  }

  function primaAveva(prima, scheda) {
    for (var i = 0; i < prima.length; i++) {
      if (prima[i][0] === scheda) return prima[i][1];
    }
    return 0;
  }

  function completa(taglia, prima) {
    taglia = Number(taglia) || 0;
    if (!taglia) return;

    /* 1. cosa ha tolto questo cambio di pacchetto */
    if (prima) {
      schede().forEach(function (s) {
        var tolti = primaAveva(prima, s) - quantita(s);
        if (tolti > 0) memoria.push({ scheda: s, unita: tolti });
      });
      while (memoria.length > MAX_MEMORIA) memoria.shift();
    }

    /* 2. si rimette prima quello che era stato tolto, dall'ultimo tolto */
    var mancano = taglia - totale();
    var giri = 0;
    while (mancano > 0 && memoria.length && giri < 100) {
      giri++;
      var voce = memoria[memoria.length - 1];
      if (!voce.scheda || !document.contains(voce.scheda) || voce.unita <= 0) { memoria.pop(); continue; }
      if (!aggiungiUno(voce.scheda)) { memoria.pop(); continue; }
      voce.unita -= 1;
      if (voce.unita <= 0) memoria.pop();
      mancano -= 1;
    }

    /* 3. se manca ancora, si completa coi gusti mai scelti, in ordine */
    if (mancano > 0) {
      var libere = schede().filter(function (s) { return quantita(s) === 0; });
      for (var i = 0; i < libere.length && mancano > 0; i++) {
        if (aggiungiUno(libere[i])) mancano -= 1;
      }
    }

    /* 4. il riquadro acceso deve essere quello scelto.
       Il tema ridimensiona il pacchetto solo quando cambia un NUCLEO, e
       scendendo di taglia l'ultimo ricalcolo capita a meta' strada: i
       nuclei sono ancora quelli vecchi, quindi il riquadro restava sul
       pacchetto grande e si leggeva "6/10". Qui lo mettiamo a posto a
       cose finite; contatore, prezzo e pulsante li riallinea da solo
       sincronizzaDopoCambioPack, che gira 120 ms dopo ogni clic sul
       pacchetto. */
    var riquadro = document.querySelector('.pack-option[data-pack="' + taglia + '"]');
    var packCambiato = false;
    if (riquadro && !riquadro.classList.contains('selected')) {
      document.querySelectorAll('.pack-option').forEach(function (p) { p.classList.remove('selected'); });
      riquadro.classList.add('selected');
      packCambiato = true;
    }

    /* 5. il prezzo in testata lo scrive il tema dentro i gestori dei
       NUCLEI, usando il pacchetto attivo in quel momento. Scendendo di
       taglia l'ultimo conto e' stato fatto quando il riquadro acceso era
       ancora quello grande, quindi restava scritto 69,95 sopra un 6/6.
       Gli facciamo rifare il conto togliendo e rimettendo subito un
       nucleo: due clic di fila, senza disegno in mezzo, quindi a schermo
       non si vede niente e lo stato finale e' identico. */
    if (packCambiato) {
      var conNuclei = schede().filter(function (s) { return quantita(s) > 0; });
      if (conNuclei.length) {
        var meno = conNuclei[0].querySelector('.quantity-selector .minus-btn');
        var piu = conNuclei[0].querySelector('.quantity-selector .plus-btn');
        if (meno && piu) { meno.click(); piu.click(); }
      }
    }
  }

  window.abNuclei = window.abNuclei || {};
  window.abNuclei.istantanea = istantanea;
  window.abNuclei.completa = completa;
})();
